export default __webpack_public_path__ + "static/media/fullscreen.450b3f1f.svg";